import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const ArrowUpIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <mask
                id="mask0_7055_77245"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_7055_77245)">
                <path
                    d="M6.69919 14.651C6.51643 14.4684 6.42505 14.236 6.42505 13.9537C6.42505 13.6714 6.51643 13.439 6.69919 13.2564L11.2848 8.67386C11.3845 8.57424 11.4925 8.50351 11.6088 8.46167C11.7251 8.42049 11.8497 8.3999 11.9826 8.3999C12.1155 8.3999 12.2401 8.42049 12.3564 8.46167C12.4727 8.50351 12.5807 8.57424 12.6804 8.67386L17.2909 13.2813C17.4737 13.4639 17.565 13.6881 17.565 13.9537C17.565 14.2194 17.4654 14.4518 17.266 14.651C17.0832 14.8337 16.8506 14.925 16.5682 14.925C16.2857 14.925 16.0531 14.8337 15.8704 14.651L11.9826 10.7659L8.06988 14.6759C7.88712 14.8586 7.66283 14.9499 7.397 14.9499C7.13116 14.9499 6.89856 14.8503 6.69919 14.651Z"
                    fill={color}
                />
            </g>
        </svg>
    );
};

export default React.memo(ArrowUpIcon);
